import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { MsalProvider } from '@azure/msal-react';
import './index.css';
import App from './App';
import { msalConfig } from './config/authConfig';

// Initialize MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

// Listen for all MSAL events
msalInstance.addEventCallback((event) => {
  console.log('🔵 MSAL Event:', event.eventType, event.payload);

  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    console.log('✅ LOGIN_SUCCESS - Setting active account:', event.payload.account.username);
    msalInstance.setActiveAccount(event.payload.account);
  }

  if (event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS && event.payload.account) {
    console.log('✅ TOKEN_SUCCESS - Account:', event.payload.account.username);
  }
});

// Loading component
function InitializingApp() {
  const [isInitialized, setIsInitialized] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    async function initialize() {
      try {
        console.log('🔄 Initializing MSAL...');

        // CRITICAL: Initialize MSAL instance first
        await msalInstance.initialize();
        console.log('✅ MSAL instance initialized');

        // Handle redirect promise and wait for it to complete
        const response = await msalInstance.handleRedirectPromise();

        if (response !== null && response.account) {
          // User just logged in via redirect from Microsoft
          console.log('✅ Redirect callback received - User:', response.account.username);
          console.log('✅ Setting active account after redirect');
          msalInstance.setActiveAccount(response.account);

          // Give extra time for MSAL state to stabilize
          await new Promise(resolve => setTimeout(resolve, 500));
        } else {
          // No redirect, check for existing session
          const accounts = msalInstance.getAllAccounts();
          if (accounts.length > 0) {
            console.log('✅ Found cached account:', accounts[0].username);
            msalInstance.setActiveAccount(accounts[0]);
          } else {
            console.log('ℹ️ No cached account found - user needs to login');
          }
        }

        // Verify account is set
        const activeAccount = msalInstance.getActiveAccount();
        if (activeAccount) {
          console.log('✅ Active account confirmed:', activeAccount.username);
        }

        console.log('✅ MSAL initialization complete');
        setIsInitialized(true);

      } catch (err) {
        console.error('❌ MSAL initialization error:', err);
        setError(err.message);
        // Still render the app even on error
        setIsInitialized(true);
      }
    }

    initialize();
  }, []);

  if (error) {
    return (
      <div style={{ padding: '20px', color: 'red' }}>
        <h3>Authentication Error</h3>
        <p>{error}</p>
        <button onClick={() => window.location.reload()}>Reload</button>
      </div>
    );
  }

  if (!isInitialized) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
        flexDirection: 'column',
        gap: '16px',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      }}>
        <div style={{
          border: '4px solid #f3f3f3',
          borderTop: '4px solid #0078d4',
          borderRadius: '50%',
          width: '50px',
          height: '50px',
          animation: 'spin 1s linear infinite',
        }}></div>
        <p style={{ color: '#605e5c', fontSize: '14px' }}>Initializing authentication...</p>
        <style>{`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    );
  }

  return (
    <MsalProvider instance={msalInstance}>
      <App />
    </MsalProvider>
  );
}

// Render the app
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <InitializingApp />
  </React.StrictMode>
);
/* Force rebuild Thu Mar  5 23:35:57 FLEST 2026 */
